import { IconNames } from '@blueprintjs/icons';
import { DetailLabelValuePair } from '@strata/react-label-value-pairs';

import {
    type BasePayerRequestAdditonalData,
    BasePayerRequestNotification,
    type CommonPayerRequestNotificationProps,
} from 'components/notifications/BasePayerRequestNotification';
import { useUserNameMap } from 'store/api/authApi';

export interface NewPayerRequestNotificationProps extends CommonPayerRequestNotificationProps {
    small: boolean;
    additionalData: BasePayerRequestAdditonalData & {
        submitterUpn: string;
    };
}

export const NewPayerRequestNotification = ({
    linkingId,
    timestamp,
    additionalData,
    onNotificationClick,
    onRemoveNotificationClick,
    status,
    small,
    payerId,
}: NewPayerRequestNotificationProps) => {
    const userNameMap = useUserNameMap(payerId);

    return (
        <BasePayerRequestNotification
            notificationTitle="New Request"
            icon={IconNames.CHAT}
            additionalDataComponent={
                <div className="flex__gap--small" style={{ flexDirection: 'column' }}>
                    <div className="sds_payer-request-notification__action-by">{`Created by ${userNameMap?.[additionalData.submitterUpn] || additionalData.submitterUpn}`}</div>
                    {!small && (
                        <DetailLabelValuePair
                            label="Request #"
                            value={additionalData.requestNumber?.toString().padStart(6, '0')}
                        />
                    )}
                </div>
            }
            additionalData={additionalData}
            linkingId={linkingId}
            onNotificationClick={onNotificationClick}
            onRemoveNotificationClick={onRemoveNotificationClick}
            payerId={payerId}
            status={status}
            timestamp={timestamp}
        />
    );
};
